/* eslint-disable no-undef */
export const BASE_URL =
    (window.location.hostname === 'www.scgtracking.com' || window.location.hostname === 'scgtracking.com')
        ? 'https://api.scgtracking.com' : (window.location.hostname.includes('localhost'))
        ? 'http://localhost:3000' : (window.location.hostname.includes('second')) ? 'https://second-api.scgtracking.com' : 'https://time-trakz-api-stag.herokuapp.com';
export const LOGIN = `${BASE_URL}/sign_in`;

export const LOAD_PATHS = {
  API_LOAD_PROJECTS: `${BASE_URL}/projects`,
  API_LOAD_EQUIPMENTS: `${BASE_URL}/equipment`,
  API_LOAD_EMPLOYEES: `${BASE_URL}/employees`,
  API_LOAD_CLIENTS: `${BASE_URL}/clients`,
  API_LOAD_LABOR_CLASSES: `${BASE_URL}/labor_classes`,
  API_LOAD_PAYMENT_TYPES: `${BASE_URL}/payment_types`,
  API_LOAD_WORK_ORDER: `${BASE_URL}/workorders`,
  API_LOAD_WORK_ORDERS: `${BASE_URL}/workorders`,
  API_LOAD_SUBCONTRACTORS: `${BASE_URL}/subcontractors`,
  API_LOAD_COST_CODES: `${BASE_URL}/cost_codes`,
  API_LOAD_COST_CODE_CATEGORIES: `${BASE_URL}/cost_code_categories`,
  API_LOAD_EQUIPMENT_CATEGORIES: `${BASE_URL}/equipment_categories`,
  API_LOAD_WORK_ORDER_PDF: `${BASE_URL}/workorders/{id}/pdf`,
  API_LOAD_EMPLOYEE_STATS: `${BASE_URL}/employee_timesheets`,
  API_LOAD_SUBCONTRACTOR_STATS: `${BASE_URL}/subcontractor_timesheets`,
};

export const REMOVE_PATHS = {
  API_REMOVE_PROJECT: `${BASE_URL}/projects/{id}`,
  API_REMOVE_EQUIPMENT: `${BASE_URL}/equipment/{id}`,
  API_REMOVE_EMPLOYEE: `${BASE_URL}/employees/{id}`,
  API_REMOVE_CLIENT: `${BASE_URL}/clients/{id}`,
  API_REMOVE_PAYMENT_TYPE: `${BASE_URL}/payment_types/{id}`,
  API_REMOVE_LABOR_CLASS: `${BASE_URL}/labor_classes/{id}`,
  API_REMOVE_WORK_ORDER: `${BASE_URL}/workorders/{id}`,
  API_REMOVE_EMPLOYEE_TIMESHEET: `${BASE_URL}/employee_timesheets/{id}`,
  API_REMOVE_EQUIPMENT_TIMESHEET: `${BASE_URL}/equipment_timesheets/{id}`,
  API_REMOVE_SUBCONTRACTOR_TIMESHEET: `${BASE_URL}/subcontractor_timesheets/{id}`,
  API_REMOVE_MATERIAL: `${BASE_URL}/materials/{id}`,
  API_REMOVE_SUBCONTRACTOR: `${BASE_URL}/subcontractors/{id}`,
  API_REMOVE_COST_CODE: `${BASE_URL}/cost_codes/{id}`,
  API_REMOVE_COST_CODE_CATEGORY: `${BASE_URL}/cost_code_categories/{id}`,
  API_REMOVE_EQUIPMENT_CATEGORY: `${BASE_URL}/equipment_categories/{id}`,
  API_REMOVE_ASSIGN_PROJECT: `${BASE_URL}/projects/{id}/assign`,
};

export const CREATE_PATHS = {
  API_CREATE_PROJECT: `${BASE_URL}/projects/`,
  API_CREATE_EQUIPMENT: `${BASE_URL}/equipment/`,
  API_CREATE_EMPLOYEE: `${BASE_URL}/employees/`,
  API_CREATE_CLIENT: `${BASE_URL}/clients/`,
  API_CREATE_PAYMENT_TYPE: `${BASE_URL}/payment_types/`,
  API_CREATE_LABOR_CLASS: `${BASE_URL}/labor_classes/`,
  API_CREATE_WORK_ORDER: `${BASE_URL}/workorders/`,
  API_CREATE_SUBCONTRACTOR: `${BASE_URL}/subcontractors/`,
  API_CREATE_COST_CODE: `${BASE_URL}/cost_codes/`,
  API_CREATE_COST_CODE_CATEGORY: `${BASE_URL}/cost_code_categories/`,
  API_CREATE_EQUIPMENT_CATEGORY: `${BASE_URL}/equipment_categories/`,
  API_CREATE_EMPLOYEE_TIMESHEET: `${BASE_URL}/workorders/{workorder_id}/employee_timesheets/`,
  API_CREATE_EQUIPMENT_TIMESHEET: `${BASE_URL}/workorders/{workorder_id}/equipment_timesheets/`,
  API_CREATE_SUBCONTRACTOR_TIMESHEET: `${BASE_URL}/workorders/{workorder_id}/subcontractor_timesheets/`,
  API_CREATE_MATERIAL: `${BASE_URL}/workorders/{workorder_id}/materials/`,
  API_CREATE_ASSIGN_PROJECT: `${BASE_URL}/projects/{id}/assign`,
};

export const UPDATE_PATHS = {
  API_UPDATE_PROJECT: `${BASE_URL}/projects/`,
  API_UPDATE_EQUIPMENT: `${BASE_URL}/equipment/`,
  API_UPDATE_EMPLOYEE: `${BASE_URL}/employees/`,
  API_UPDATE_CLIENT: `${BASE_URL}/clients/`,
  API_UPDATE_PAYMENT_TYPE: `${BASE_URL}/payment_types/`,
  API_UPDATE_LABOR_CLASS: `${BASE_URL}/labor_classes/`,
  API_UPDATE_WORK_ORDER: `${BASE_URL}/workorders/`,
  API_UPDATE_SUBCONTRACTOR: `${BASE_URL}/subcontractors/`,
  API_UPDATE_COST_CODE: `${BASE_URL}/cost_codes/`,
  API_UPDATE_COST_CODE_CATEGORY: `${BASE_URL}/cost_code_categories/`,
  API_UPDATE_EQUIPMENT_CATEGORY: `${BASE_URL}/equipment_categories/`,
  API_UPDATE_EMPLOYEE_TIMESHEET: `${BASE_URL}/employee_timesheets/`,
  API_UPDATE_EQUIPMENT_TIMESHEET: `${BASE_URL}/equipment_timesheets/`,
  API_UPDATE_SUBCONTRACTOR_TIMESHEET: `${BASE_URL}/subcontractor_timesheets/`,
  API_UPDATE_MATERIAL: `${BASE_URL}/materials/`,
};



// WEBPACK FOOTER //
// ./src/helpers/api/apiPaths.js